import * as yup from 'yup'

const ChequeBookValidataionSchema = yup.object().shape({
    bankName: yup.string().trim().required("This Field is required"),
    accNo: yup.string().trim().required("This Field is required"),
    ifscCode: yup.string().trim().required("This Field is required"),
    chequeSeriesFrom: yup.string().trim().required("This Field is required"),
    chequeSeriesTo: yup.string().trim().required("This Field is required"),
})


export { ChequeBookValidataionSchema }